// Centralized string-literal enums shared between web and api.
// Kept as `as const` arrays + derived union types so Zod / Prisma stay in sync.
export const USER_ROLES = ['OWNER', 'ADMIN', 'OPERATOR', 'DEVELOPER', 'VIEWER'];
export const TENANT_STATUSES = ['ACTIVE', 'SUSPENDED', 'TRIAL'];
// Mirrors Prisma's UPPERCASE enums so wire payloads match DB enums 1:1.
export const AGENT_STATUSES = ['LIVE', 'DRAFT', 'PAUSED', 'ARCHIVED'];
export const RISK_LEVELS = ['LOW', 'MEDIUM', 'HIGH', 'CRITICAL'];
export const MCP_CATEGORIES = [
    'DMS',
    'OCR',
    'CRM',
    'ERP',
    'CALENDAR',
    'WORKFLOW',
    'KNOWLEDGE',
    'HR',
    'RECRUITING',
    'CUSTOM',
];
export const MCP_AUTH_TYPES = ['API_KEY', 'OAUTH2', 'BASIC', 'SERVICE_ACCOUNT', 'NONE'];
export const TOOL_PERMISSIONS = ['ALLOW', 'DENY', 'APPROVAL_REQUIRED'];
export const CHANNEL_TYPES = ['WHATSAPP', 'SMS', 'TELEGRAM', 'LINE', 'WEBCHAT', 'EMAIL'];
export const CHANNEL_PROVIDERS = [
    'BAILEYS',
    'INFOBIP',
    'BIRD',
    'META_CLOUD',
    'TWILIO',
    'CUSTOM',
];
export const CHANNEL_STATUSES = ['CONNECTED', 'DISCONNECTED', 'MISSING', 'AVAILABLE'];
// Inputs allow status changes only across these explicit values.
export const CHANNEL_STATUSES_INPUT = ['CONNECTED', 'DISCONNECTED', 'AVAILABLE'];
export const WHATSAPP_STATUSES = [
    'NOT_STARTED',
    'QR_PENDING',
    'CONNECTED',
    'DISCONNECTED',
    'ERROR',
];
export const CONVERSATION_STATUSES = [
    'NEW',
    'IN_PROGRESS',
    'NEEDS_HUMAN',
    'COMPLETED',
    'FAILED',
];
export const MESSAGE_DIRECTIONS = ['INBOUND', 'OUTBOUND'];
export const SENDER_TYPES = ['USER', 'BOT', 'HUMAN', 'SYSTEM'];
export const CONTENT_TYPES = [
    'TEXT',
    'IMAGE',
    'DOCUMENT',
    'AUDIO',
    'VIDEO',
    'LOCATION',
    'SYSTEM',
];
export const TOOL_CALL_STATUSES = ['SUCCESS', 'FAILED', 'PENDING', 'SKIPPED'];
export const WORKFLOW_STATUSES = ['ACTIVE', 'PAUSED', 'DRAFT'];
export const SOCKET_EVENTS = {
    WhatsAppQr: 'whatsapp:qr',
    WhatsAppStatus: 'whatsapp:status',
    WhatsAppMessageNew: 'whatsapp:message:new',
    WhatsAppDocumentReceived: 'whatsapp:document:received',
    ConversationUpdated: 'conversation:updated',
};
//# sourceMappingURL=enums.js.map